import { atomWithStorage } from 'jotai/utils'
import { STORAGE_KEY_NAME } from '../constants'

type IMenuState = boolean

const storageKey: string = `${STORAGE_KEY_NAME}/isMenuOpen`
const defaultState: IMenuState = false

// Set the string key and the initial value
export const menuIsOpenAtom = atomWithStorage<IMenuState>(
	storageKey,
	defaultState,
	undefined,
	{
		getOnInit: true // If the stored value is preferred set getOnInit to true
	}
)

// smth like 'action-creators' from redux
export const turnOnMenu = (currVal: IMenuState) => true
export const turnOffMenu = (currVal: IMenuState) => false

export const toggleMenu = (currVal: IMenuState) => !currVal
